<template>
	<div class="org_en">
		<div class="org_en_pc" v-if="!isPhone">
			<div class="hd_img">
				<img src="@/images/lishi/eng/newhead.png">
			</div>
			<div class="org_img">
				<!-- 1 -->
				<div class="org_item flex1" data-aos="fade-up">
					<div class="otm_left">
						<img src="@/images/lishi/eng/cmg1.png">
					</div>
					<div class="otm_right">
						<div class="flex3 ort_p1">
							<p>3000 BC (Ancient Shu Civilization)</p>
							<img src="@/images/lishi/eng/zhen.png">
						</div>
						<div class="ort_p2">Located about 30 kilometers from Mianzhu, the liquor-making site of Jiannanchun, the
							Sanxingdui Ruins have yielded numerous precious wine utensils. Among the findings in Mianzhu are a
							significant collection of wine containers and brewing tools of late Ancient Shu period, including bronze lei
							and ewers dating back to the Warring States period. These artifacts highlight the advanced civilization and
							flourishing wine industry that characterized the Mianzhu region during the same period.</div>
					</div>
				</div>
				<!-- 2 -->
				<div class="org_item flex1" data-aos="fade-up">
					<div class="otm_right" style="margin-left: 0;">
						<div class="flex3 ort_p1">
							<p>487 AD (5th Year of Yongming, Southern Qi </p>
						</div>
						<div class="flex3 ort_p1">
							<p>Dynasty)</p>
							<img src="@/images/lishi/eng/zhen.png">
						</div>
						<div class="ort_p2">In 1985, a brick inscribed with the characters "永明五年" ("the 5th Year of Yongming" in English
							translation) was discovered at the Tianyi Laohao Brewing Workshop. After comprehensive archaeological
							assessment, experts concluded that the underground cellar of the Tianyi Laohao Brewing Workshop was
							constructed no later than the 5th year of Yongming, proving that Jiannanchun has a well-documented brewing
							history dating back over 1,500 years.</div>
					</div>
					<div class="otm_left" style="margin-left: 40px;">
						<img src="@/images/lishi/eng/cmg2.png">
					</div>
				</div>
				<!-- 3 -->
				<div class="org_item flex1" data-aos="fade-up">
					<div class="otm_left">
						<img src="@/images/lishi/eng/cmg3.png">
					</div>
					<div class="otm_right">
						<div class="flex3 ort_p1">
							<p>618–779 AD (Tang Dynasty Period)</p>
							<img src="@/images/lishi/eng/zhen.png">
						</div>
						<div class="ort_p2">Jiannan Shaochun, an early variant of the brand's liquor, was once served as imperial liquor
							at the Tang Dynasty court. Notably mentioned in the Old Book of Tang: Annals of Emperor Dezong of Tang, the
							liquor holds a significant place in Chinese history and continues to thrive today.</div>
					</div>
				</div>
				<!-- 4 -->
				<div class="org_item flex1" data-aos="fade-up">
					<div class="otm_right" style="margin-left: 0;">
						<div class="flex3 ort_p1">
							<p>Late 19th Century – Early 20th Century</p>
							<img src="@/images/lishi/eng/zhen.png">
						</div>
						<div class="ort_p3">During the late Qing Dynasty, the wine industry in Mianzhu flourished, with over 100 brewing workshops operating. Mianzhu Daqu won first prize in the liquor category at the inaugural Commercial Industrial Exhibition. In the Republic of China period, the first Famous Products Exhibition was held in Sichuan Province, and Mianzhu Daqu was approved to use a registered trademark for the first time, making a splash with its new appearance.</div>
					</div>
				</div>
				<!-- 5 -->
				<div class="org_item flex1" data-aos="fade-up">
					<div class="otm_right" style="margin-left: 0;">
						<div class="flex3 ort_p1">
							<p>1951</p>
							<img src="@/images/lishi/eng/zhen.png">
						</div>
						<div class="ort_p3">The People's Government of Mianzhu City nationalized more than 30 local distilleries,
							including Zhutianyi, Yanghengshun, Taifutong, and Tianchengxiang, establishing the "Sichuan Mianzhu Local
							State-Owned Distillery," the predecessor of "Sichuan Jiannanchun (Group) Co., Ltd."</div>
					</div>
				</div>
				<!-- 6 -->
				<div class="org_item flex1" data-aos="fade-up">
					<div class="otm_right" style="margin-left: 0;">
						<div class="flex3 ort_p1">
							<p>1979, 1984 and 1989</p>
							<img src="@/images/lishi/eng/zhen.png">
						</div>
						<div class="ort_p3">As the flagship product of the distillery, Jiannanchun was honored with the title of
							National Famous Liquor at the National Liquor Tasting Conference organized by the former Ministry of Light
							Industry in 1979, 1984, and 1989.</div>
					</div>
				</div>
				<!-- 7 -->
				<div class="org_item flex1" data-aos="fade-up">
					<div class="otm_right" style="margin-left: 0;">
						<div class="flex3 ort_p1">
							<p>1990s</p>
							<img src="@/images/lishi/eng/zhen.png">
						</div>
						<div class="ort_p3">In the 1990s, Jiannanchun strengthened international cooperation and received delegations
							from the United States, Germany, the United Kingdom, France, the Netherlands, Japan, South Korea, Thailand,
							and South Africa. The company actively participated in international expos, such as the Chicago Import and
							Export Fair, Leipzig Autumn Fair (Gold Medal), London Wine Fair, and the Asia-Pacific International Trade
							Expo, winning multiple gold medals and gaining global consumer recognition. In 1995, Jiannanchun was approved
							by the Ministry of Foreign Trade and Economic Cooperation to conduct import and export operations.</div>
					</div>
				</div>
				<!-- 8 -->
				<div class="org_item flex1" data-aos="fade-up">
					<div class="otm_right" style="margin-left: 0;">
						<div class="flex3 ort_p1">
							<p>2005</p>
							<img src="@/images/lishi/eng/zhen.png">
						</div>
						<div class="ort_p3">Jiannanchun became the first Chinese liquor brand granted the Mark of Pure Grain Solid-State
							Fermented Liquor by the China National Food Industry Association.</div>
					</div>
				</div>
				<!-- 9 -->
				<div class="org_item flex1" data-aos="fade-up">
					<div class="otm_right" style="margin-left: 0;">
						<div class="flex3 ort_p1">
							<p>2006</p>
							<img src="@/images/lishi/eng/zhen.png">
						</div>
						<div class="ort_p3">Jiannanchun was recognized as one of the first Time-Honored Chinese Brand by the Ministry of
							Commerce of the People's Republic of China and its traditional brewing techniques were recognized as a
							national intangible cultural heritage item.</div>
					</div>
				</div>
				<!-- 10 -->
				<div class="org_item flex1" data-aos="fade-up">
					<div class="otm_right" style="margin-left: 0;">
						<div class="flex3 ort_p1">
							<p>2021</p>
							<img src="@/images/lishi/eng/zhen.png">
						</div>
						<div class="ort_p3">In 2021, Jiannanchun was successfully included in the list of China-EU Geographical
							Indications. To date, both "Jiannanchun Chiew" and "Mianzhu Daqu (Fuxingxiang)" have obtained geographical
							indication certifications and are highly acclaimed in European and global markets for their outstanding
							quality.</div>
					</div>
				</div>
				<!-- 11 -->
				<div class="org_item flex1" data-aos="fade-up">
					<div class="otm_right" style="margin-left: 0;">
						<div class="flex3 ort_p1">
							<p>To This Day</p>
							<img src="@/images/lishi/eng/zhen.png">
						</div>
						<div class="ort_p3">Jiannanchun has led the industry in sales volume over the years, earning widespread
							recognition for its brand influence and reputation. The brand has achieved significant acclaim, with over 30
							brands and hundreds of products repeatedly winning national, ministerial, and provincial quality awards.
						</div>
					</div>
				</div>
			</div>
		</div>
		<div class="org_en_ph" v-if="isPhone">
			<enHeader2 :searchShow="true"></enHeader2>
			<div class="hd_img">
				<img src="@/images/lishi/eng/newhead2.png">
			</div>
			<div class="org_img2">
				<!-- 1 -->
				<div class="phimg_item" data-aos="fade-up">
					<img class="ptm_zt" src="@/images/lishi/eng/cmg1.png">
					<img class="ptm_yun" src="@/images/lishi/eng/hmg1.png">
					<div class="ptm_tit">3000 BC (Ancient Shu Civilization)</div>
					<div class="ptm_con">Located about 30 kilometers from Mianzhu, the liquor-making site of Jiannanchun, the
							Sanxingdui Ruins have yielded numerous precious wine utensils. Among the findings in Mianzhu are a
							significant collection of wine containers and brewing tools of late Ancient Shu period, including bronze lei
							and ewers dating back to the Warring States period. These artifacts highlight the advanced civilization and
							flourishing wine industry that characterized the Mianzhu region during the same period.</div>
				</div>
				<!-- 2 -->
				<div class="phimg_item" data-aos="fade-up">
					<img class="ptm_zt" src="@/images/lishi/eng/cmg2.png">
					<img class="ptm_yun" src="@/images/lishi/eng/hmg1.png">
					<div class="ptm_tit">487 AD (5th Year of Yongming, Southern Qi Dynasty)</div>
					<div class="ptm_con">In 1985, a brick inscribed with the characters "永明五年" ("the 5th Year of Yongming" in English
							translation) was discovered at the Tianyi Laohao Brewing Workshop. After comprehensive archaeological
							assessment, experts concluded that the underground cellar of the Tianyi Laohao Brewing Workshop was
							constructed no later than the 5th year of Yongming, proving that Jiannanchun has a well-documented brewing
							history dating back over 1,500 years.</div>
				</div>
				<!-- 3 -->
				<div class="phimg_item" data-aos="fade-up">
					<img class="ptm_zt" src="@/images/lishi/eng/cmg3.png">
					<img class="ptm_yun" src="@/images/lishi/eng/hmg1.png">
					<div class="ptm_tit">618–779 AD (Tang Dynasty Period)</div>
					<div class="ptm_con">Jiannan Shaochun, an early variant of the brand's liquor, was once served as imperial liquor
							at the Tang Dynasty court. Notably mentioned in the Old Book of Tang: Annals of Emperor Dezong of Tang, the
							liquor holds a significant place in Chinese history and continues to thrive today.</div>
				</div>
				<!-- 4 -->
				<div class="phimg_item" data-aos="fade-up">
					<img class="ptm_yun" src="@/images/lishi/eng/hmg1.png">
					<div class="ptm_tit">Late 19th Century – Early 20th Century</div>
					<div class="ptm_con">During the late Qing Dynasty, the wine industry in Mianzhu flourished, with over 100 brewing workshops operating. Mianzhu Daqu won first prize in the liquor category at the inaugural Commercial Industrial Exhibition. In the Republic of China period, the first Famous Products Exhibition was held in Sichuan Province, and Mianzhu Daqu was approved to use a registered trademark for the first time, making a splash with its new appearance.</div>
				</div>
                <!-- 5 -->
				<div class="phimg_item" data-aos="fade-up">
					<img class="ptm_yun" src="@/images/lishi/eng/hmg1.png">
					<div class="ptm_tit">1951</div>
					<div class="ptm_con">The People's Government of Mianzhu City nationalized more than 30 local distilleries,
							including Zhutianyi, Yanghengshun, Taifutong, and Tianchengxiang, establishing the "Sichuan Mianzhu Local
							State-Owned Distillery," the predecessor of "Sichuan Jiannanchun (Group) Co., Ltd."</div>
				</div>
                <!-- 6 -->
				<div class="phimg_item" data-aos="fade-up">
					<img class="ptm_yun" src="@/images/lishi/eng/hmg1.png">
					<div class="ptm_tit">1979, 1984 and 1989</div>
					<div class="ptm_con">As the flagship product of the distillery, Jiannanchun was honored with the title of
							National Famous Liquor at the National Liquor Tasting Conference organized by the former Ministry of Light
							Industry in 1979, 1984, and 1989.</div>
				</div>
                <!-- 7 -->
				<div class="phimg_item" data-aos="fade-up">
					<img class="ptm_yun" src="@/images/lishi/eng/hmg1.png">
					<div class="ptm_tit">1990s</div>
					<div class="ptm_con">In the 1990s, Jiannanchun strengthened international cooperation and received delegations
							from the United States, Germany, the United Kingdom, France, the Netherlands, Japan, South Korea, Thailand,
							and South Africa. The company actively participated in international expos, such as the Chicago Import and
							Export Fair, Leipzig Autumn Fair (Gold Medal), London Wine Fair, and the Asia-Pacific International Trade
							Expo, winning multiple gold medals and gaining global consumer recognition. In 1995, Jiannanchun was approved
							by the Ministry of Foreign Trade and Economic Cooperation to conduct import and export operations.</div>
				</div>
                <!-- 8 -->
				<div class="phimg_item" data-aos="fade-up">
					<img class="ptm_yun" src="@/images/lishi/eng/hmg1.png">
					<div class="ptm_tit">2005</div>
					<div class="ptm_con">Jiannanchun became the first Chinese liquor brand granted the Mark of Pure Grain Solid-State
                        Fermented Liquor by the China National Food Industry Association.</div>
				</div>
                <!-- 9 -->
				<div class="phimg_item" data-aos="fade-up">
					<img class="ptm_yun" src="@/images/lishi/eng/hmg1.png">
					<div class="ptm_tit">2006</div>
					<div class="ptm_con">Jiannanchun was recognized as one of the first Time-Honored Chinese Brand by the Ministry of
							Commerce of the People's Republic of China and its traditional brewing techniques were recognized as a
							national intangible cultural heritage item.</div>
				</div>
                <!-- 10 -->
				<div class="phimg_item" data-aos="fade-up">
					<img class="ptm_yun" src="@/images/lishi/eng/hmg1.png">
					<div class="ptm_tit">2021</div>
					<div class="ptm_con">In 2021, Jiannanchun was successfully included in the list of China-EU Geographical
							Indications. To date, both "Jiannanchun Chiew" and "Mianzhu Daqu (Fuxingxiang)" have obtained geographical
							indication certifications and are highly acclaimed in European and global markets for their outstanding
							quality.</div>
				</div>
                <!-- 11 -->
				<div class="phimg_item" data-aos="fade-up">
					<img class="ptm_yun" src="@/images/lishi/eng/hmg1.png">
					<div class="ptm_tit">To This Day</div>
					<div class="ptm_con">Jiannanchun has led the industry in sales volume over the years, earning widespread
							recognition for its brand influence and reputation. The brand has achieved significant acclaim, with over 30
							brands and hundreds of products repeatedly winning national, ministerial, and provincial quality awards.</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	data() {
		return {
			isPhone: this.$isMobile,
			staticImg: this.$staticImg,
		};
	},
	methods: {

	},
}
</script>

<style lang="scss">
@function vw($size) {
	@return $size/1920 * 100vw;
}
.org_en {
	@font-face {
		font-family: "SourceHanSerifCN";
		src: url("../../font/SourceHanSerifCN-Heavy.otf");
	}
	font-family: "SourceHanSerifCN";
	@font-face {
		font-family: "SourceHanSerif";
		src: url("../../font/SourceHanSerifCN-Regular.otf");
	}
	.org_en_pc {
		min-width: 950px;
		min-height: calc(100vh - 220px);
		padding-top: 80px;
		background-color: #eceaeb;
		background-image: url("../../images/bgimg3.png");
		.hd_img {
			img {
				width: 100%;
			}
		}
		.org_img {
			padding-bottom: 40px;
			width: 1270px;
			margin: 0 auto;
			.org_item {
				background-size: 100% 100%;
				background-repeat: no-repeat;
				padding: 33px 40px;
				margin-bottom: 40px;
				&:nth-child(1) {
					background-image: url("../../images/lishi/eng/cg1.png");
				}
				&:nth-child(2) {
					background-image: url("../../images/lishi/eng/cg2.png");
				}
				&:nth-child(3) {
					background-image: url("../../images/lishi/eng/cg3.png");
				}
				&:nth-child(4) {
					background-image: url("../../images/lishi/eng/cg4.png");
				}
				&:nth-child(5) {
					background-image: url("../../images/lishi/eng/cg5.png");
				}
				&:nth-child(6) {
					background-image: url("../../images/lishi/eng/cg6.png");
				}
				&:nth-child(7) {
					background-image: url("../../images/lishi/eng/cg7.png");
				}
				&:nth-child(8) {
					background-image: url("../../images/lishi/eng/cg8.png");
				}
				&:nth-child(9) {
					background-image: url("../../images/lishi/eng/cg8.png");
				}
				&:nth-child(10) {
					background-image: url("../../images/lishi/eng/cg8.png");
				}
				&:nth-child(11) {
					background-image: url("../../images/lishi/eng/cg8.png");
				}
				.otm_left {
					width: 234px;
				}
				.otm_right {
					flex: 1;
					text-align: left;
					margin-left: 40px;
					.ort_p1 {
						align-items: flex-end;
						p {
							font-size: 38px;
							color: #8e4d4d;
							font-weight: 600;
						}
						img {
							width: 80px;
							margin-bottom: 10px;
							margin-left: 10px;
						}
					}
					.ort_p2 {
						font-size: 14px;
						color: #333;
						line-height: 2;
						margin-top: 28px;
						font-family: "SourceHanSerif";
					}
					.ort_p3 {
						font-size: 14px;
						color: #333;
						line-height: 2;
						margin-top: 44px;
						font-family: "SourceHanSerif";
					}
				}
			}
		}
	}
	@media screen and (max-width: 1500px) {
		.org_en_pc {
			.org_img {
				width: 1100px;
				.org_item {
					.otm_right {
						.ort_p1 {
							p {
								font-size: 32px;
							}
						}
					}
				}
			}
		}
	}
	@media screen and (max-width: 1300px) {
		.org_en_pc {
			.org_img {
				padding-bottom: 40px;
				width: 1000px;
				margin: 0 auto;
				.org_item {
					.otm_left {
						width: 200px;
						img {
							width: 200px;
						}
					}
					.otm_right {
						.ort_p1 {
							p {
								font-size: 26px;
							}
							img {
								width: 60px;
							}
						}
						.ort_p2 {
							font-size: 14px;
							line-height: 1.6;
							margin-top: 28px;
						}
						.ort_p3 {
							font-size: 14px;
							line-height: 1.6;
							margin-top: 60px;
						}
					}
				}
			}
		}
	}
	.org_en_ph {
		padding-top: 1.23rem;
		background-image: url("../../images/bgimg3.png");
		.hd_img {
			img {
				width: 100%;
			}
		}
		.org_img2 {
			padding: 0.3rem 0.4rem 1rem 0.4rem;
			.phimg_item {
				position: relative;
				background-image: url("../../images/lishi/eng/hbg1.png");
				background-repeat: no-repeat;
				background-size: 100% 100%;
				padding: 0.68rem;
                margin-bottom: 0.5rem;
				.ptm_zt {
					width: 5.7rem;
					margin-bottom: 0.5rem;
				}
				.ptm_tit {
					font-size: 0.58rem;
					font-weight: bold;
					color: #8e4d4d;
				}
				.ptm_con {
					margin-top: 0.5rem;
					font-family: "SourceHanSerif";
					font-size: 0.34rem;
					line-height: 2;
                    text-align: left;
				}
				.ptm_yun {
					position: absolute;
					top: 0.68rem;
					right: 0;
					width: 3.9rem;
					z-index: 0;
				}
			}
		}
	}
}
</style>